import type { ResourceType } from '@/features/common/types/ResourceType';
import type { LibraryAdminKey } from '@/i18n/dictionaries/libraryAdmin';
import type { PublicRegistryKey } from '@/i18n/dictionaries/publicRegistry';

/** Mirrors LibraryService.Resource.Type. A type missing here silently drops out of the filter. */
export const RESOURCE_TYPE = {
  guide: 'GUIDE',
  standard: 'STANDARD',
  policy: 'POLICY',
  report: 'REPORT',
  study: 'STUDY',
  publication: 'PUBLICATION',
  trainingMaterial: 'TRAINING_MATERIAL',
  video: 'VIDEO',
} as const;

/** Every type, in the order the pickers list them. */
export const RESOURCE_TYPES: readonly ResourceType[] = Object.values(RESOURCE_TYPE);

/**
 * The name each type goes by — the same strings the public card shows, so the filter, the
 * administration and the card all name the same thing. A type with no entry here would be a
 * compile error rather than a raw enum ("TRAINING_MATERIAL") in a dropdown.
 */
export const RESOURCE_TYPE_LABEL_KEY: Record<ResourceType, PublicRegistryKey & LibraryAdminKey> = {
  GUIDE: 'libraryTypeGUIDE',
  STANDARD: 'libraryTypeSTANDARD',
  POLICY: 'libraryTypePOLICY',
  REPORT: 'libraryTypeREPORT',
  STUDY: 'libraryTypeSTUDY',
  PUBLICATION: 'libraryTypePUBLICATION',
  TRAINING_MATERIAL: 'libraryTypeTRAINING_MATERIAL',
  VIDEO: 'libraryTypeVIDEO',
};
